import { connect } from 'react-redux';
import IndicatorsDashbordPers from '../../components/dashboard/indicatorsDashbord/Pers/IndicatorsDashbordPers';

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(IndicatorsDashbordPers);
